import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCircle } from "@fortawesome/free-solid-svg-icons";

export default function LiveTag() {

    return (
        <span className="text-xs text-green-500"><FontAwesomeIcon className="animate-pulse" icon={faCircle} /> Live</span>
    );
}